// extracted by mini-css-extract-plugin
export var searchHeader = "_36-0";
export var searchHeaderDark = "_36-1";